import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../controls/ExpandablePanel'
import CustomDatePicker from '../controls/CustomDatePicker'
import { formatDate, dateFromCalendar } from '../../lib/formatDateHandler'
import { controlHasError } from '../../lib/errorHandler'
import AnimateHeight from 'react-animate-height'

class CzasTrwaniaJednostki extends React.Component {
  render() {
    return (
      <ExpandablePanel title="CZAS TRWANIA DZIAŁALNOŚCI JEDNOSTKI">
        <form autoComplete="off" className="czasTrwania">
          <FormControlLabel
            className="checkboxLabel high-caption"
            control={
              <Checkbox
                name="CzyOgraniczony"
                color="primary"
                defaultChecked={this.props.data.CzyOgraniczony}
                onChange={e =>
                  this.props.onSetSectionData(
                    'CzyOgraniczony',
                    e.target.checked,
                  )
                }
              />
            }
            label="Czas trwania działalności jednostki jest ograniczony"
          />

          <AnimateHeight
            duration={250}
            height={this.props.data.CzyOgraniczony ? 'auto' : 0}
          >
            <div className="secondRow">
              <CustomDatePicker
                name="DataOd"
                error={controlHasError(this.props.errors, 'DataOd')}
                label="Początek działalności"
                value={formatDate(this.props.data.DataOd)}
                onChange={e =>
                  this.props.onSetSectionData('DataOd', dateFromCalendar(e))
                }
              />
              <p className="separator">-</p>
              <CustomDatePicker
                name="DataDo"
                error={controlHasError(this.props.errors, 'DataDo')}
                label="Koniec działalności"
                value={formatDate(this.props.data.DataDo)}
                onChange={e =>
                  this.props.onSetSectionData('DataDo', dateFromCalendar(e))
                }
              />
              <p className="operator">LUB</p>
              <TextField
                error={controlHasError(this.props.errors, 'DataDoOpis')}
                name="DataDoOpis"
                label="Koniec działalności - opis (gdy trudno wskazać konkretną datę)"
                title={this.props.data.DataDoOpis}
                defaultValue={this.props.data.DataDoOpis}
                onBlur={e =>
                  this.props.onSetSectionData('DataDoOpis', e.target.value)
                }
              />
            </div>
          </AnimateHeight>
        </form>
      </ExpandablePanel>
    )
  }
}

export default CzasTrwaniaJednostki
